class LoggerManager {
    // Logger Settings
    url = undefined;
    interval = 0;
    maxItems = 0;

    // Queue Management
    queue = [];
    lastTimeout = null;

    constructor() {
        if ('visibilityState' in document) {
            // Browser supports the "visibilitychange" event
            document.addEventListener('visibilitychange', this.sendToServer);
        } else if ('webkitHidden' in document) {
            // Browser supports the "webkitHidden" property (fallback for older WebKit-based browsers)
            document.addEventListener('webkitvisibilitychange', this.sendToServer);
        } else {
            // Fallback for browsers that don't support "visibilitychange" or "webkitvisibilitychange"
            window.addEventListener('pagehide', this.sendToServer);
        }
    }

    setUrl = (url) => {
        this.url = url;

        // If the queue is not empty, initiate sending
        if (this.queue.length > 0) {
            this.handleSending();
        }
    };

    push = (payload) => {
        this.queue.push(payload);
        this.handleSending();
    }

    handleSending = () => {
        // If the queue size reaches the maximum or the interval is 0, send logs immediately
        if (this.queue.length >= this.maxItems || this.interval === 0) {
            this.resetTimeout();
            this.sendToServer();
            return;
        }

        this.scheduleTimeout();
    };

    scheduleTimeout = () => {
        if (this.lastTimeout === null) {
            this.lastTimeout = setTimeout(this.sendToServer, this.interval);
        }
    };

    resetTimeout = () => {
        if (this.lastTimeout) {
            clearTimeout(this.lastTimeout);
        }

        this.lastTimeout = null;
    };

    sendToServer = () => {
        if (this.url && this.queue.length > 0) {
            navigator.sendBeacon(this.url, JSON.stringify(this.queue));

            // Reset queue and timeout
            this.queue = [];
            this.resetTimeout();
            return;
        }
    }
}

class AnalyticsLoggerManager extends LoggerManager {
    interval = 2 * 1000;
    maxItems = 5;
}

export const AnalyticsLogger = new AnalyticsLoggerManager();

class CrashLoggerManager extends LoggerManager {
    constructor() {
        super();

        // Add event listener for capturing global errors
        window.addEventListener('error', this.handleWindowError);
    }

    handleWindowError = (event) => {
        this.push({
            message: event.error?.message ||event.message,
            stack: event?.stack || event.error?.stack,
            filename: event.filename,
            line: event.lineno,
        });
    };
}

export const CrashLogger = new CrashLoggerManager();
